import { ka } from "../../../../date-fns/locale/ka.js";
window.dateFns = {
  ...window.dateFns,
  locale: {
    ...window.dateFns?.locale,
    ka
  }
};